export default [
  {
    path: "CallCenterSettings",
    name: "CallCenterSettings",
    meta: {
      title: "呼叫中心配置"
    },
    component: () =>import("@/views/Home/systemManage/callCenterSettings")
  },
]